<template>
  <div class="w-full">
    <vs-card
      id="notification-recluitment-loading"
      class="vs-con-loading__container"
    >
      <vs-row>
        <vs-col>
          <RecruitmentTable
            :data="data"
            :notifications="notifications"
            @search="search"
            @loadMore="loadMore"
            @updateUser="updateUser"
            @sort="sort"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import RecruitmentTable from './components/RecruitmentTable.vue'
import request from './request.js'
import loading from '@/mixins/Loading'
export default {
  components: {
    RecruitmentTable,
  },
  mixins: [loading],
  data() {
    return {
      data: [],
      notifications: [],
      params: {
        search: '',
        page: 1,
        sort: ['ASC'],
        sortBy: ['user_name'],
      },
      lastPage: 1,
      loading: {
        data: false,
        submit: false,
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.data || this.loading.submit
    },
  },
  methods: {
    getData() {
      this.loading.data = true
      const payload = {
        search: this.params.search,
        page: this.params.page,
        sort: this.params.sort[0],
        sortBy: this.params.sortBy[0],
      }

      request
        .getUsers(payload)
        .then((response) => {
          this.loading.data = false
          const data = response.data.data.data

          const rows = this.fillTable(data)
          if (this.params.page === 1) {
            this.data = [...rows]
          } else {
            this.data = [...this.data, ...rows]
          }
          this.lastPage = response.data.last_page
        })
        .catch((response) => {
          this.loading.data = false
          this.showValidationErrors(response)
        })
    },
    fillTable(data) {
      const users = [...new Set(data.map((item) => item.user_id))]
      let rows = []
      users.forEach((user) => {
        let user_data = data.find((item) => user === item.user_id)
        let row = new Object({
          user_id: user_data.user_id,
          user_name: user_data.user_name,
          user_email: user_data.email,
          notifications: [],
        })
        // console.log(data)
        this.notifications.forEach((notification) => {
          const notification_status = data.find(
            (item) =>
              notification.notification_id == item.notify_id &&
              row.user_id == item.user_id
          )
          // console.log(notification.notification_id, row.user_id,notification_status.active)
          row.notifications = [
            ...row.notifications,
            {
              notification_id: notification.notification_id,
              notification_name: notification.notification_name,
              notification_status:
                notification_status != undefined
                  ? (notification_status.active === null ||
                    notification_status.active === '0')
                    ? false
                    : true
                  : false,
            }
          ]
          // console.log(row.user_id,notification.notification_id,notification.notification_name,notification_status != undefined
          //         ? (notification_status.active === null ||
          //           notification_status.active === '0')
          //           ? false
          //           : true
          //         : false)
          
        })
        
        rows = [...rows, row]
      })

      return rows
    },
    loadMore() {
      if (this.params.page < this.params.lastPage) {
         this.params.page++
          this.getData()
      }
    },
    search(text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sort = e.sort
      this.params.sortBy = e.sortBy
      this.getData()
    },
    getNotifications() {
      this.loading.data = true
      request
        .getNotifications()
        .then((response) => {
          this.notifications = [...response.data.notifications]
          this.loading.data = false
          this.getData()
        })
        .catch((response) => {
          this.loading.data = false
          this.showValidationErrors(response)
        })
    },
    updateUser(item) {
      const payload = { ...item }
      this.loading.data = true
      request
        .updateUser(payload)
        .then((response) => {
          this.loading.data = false
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'User Updated',
          })
          this.getData()
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading.data = false
        })
    },
  },
  mounted() {
    this.getNotifications()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('notification-recluitment-loading')
      } else {
        this.closeLoading('notification-recluitment-loading')
      }
    },
  },
}
</script>

<style>
</style>
